export const GA = () => typeof gtag !== "undefined" ? gtag : null